import { useEffect, useState } from 'react';
import { getDeductionMethodMap, useQuotePriceDetailInfo } from '@jove-frontend/uikit';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var CommonPriceView = function CommonPriceView(props) {
  var title = props.title,
      content = props.content,
      className = props.className;
  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-row justify-between', className),
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "subtitle1",
      className: "font-bold text-[#0E35D1]",
      children: title
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "subtitle1",
      className: "font-bold text-[#0E35D1]",
      children: content
    })]
  });
};

var PriceComparisonOnlyJovePriceInfoView = function PriceComparisonOnlyJovePriceInfoView(props) {
  var className = props.className,
      info = props.info;

  var _useState = useState(null),
      payPriceInfo = _useState[0],
      setPayPriceInfo = _useState[1];

  var _useQuotePriceDetailI = useQuotePriceDetailInfo(),
      generateQuotePriceCurrentPayInfo = _useQuotePriceDetailI.generateQuotePriceCurrentPayInfo;
  /**
   * effects
   */


  useEffect(function () {
    if (info) {
      setPayPriceInfo(generateQuotePriceCurrentPayInfo(info));
    }
  }, [info]);
  var isMonthly = (info === null || info === void 0 ? void 0 : info.billing_cycle) === getDeductionMethodMap().monthly.value;
  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [isMonthly ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(CommonPriceView, {
        title: "Monthly premium (including IPT):",
        content: (payPriceInfo === null || payPriceInfo === void 0 ? void 0 : payPriceInfo.monthlySchedulePayText) || '-'
      }), /*#__PURE__*/_jsxs(Box, {
        className: "mt-3 flex flex-col",
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "subtitle2",
          className: "font-medium text-[#202020]",
          children: "Down Payment:"
        }), /*#__PURE__*/_jsxs(Box, {
          className: "flex flex-row justify-between",
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "subtitle2",
            className: "font-medium text-[#999]",
            children: "Including IPT and fee"
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "subtitle2",
            className: "font-medium text-[#202020]",
            children: (payPriceInfo === null || payPriceInfo === void 0 ? void 0 : payPriceInfo.monthlyCurrentPayText) || '-'
          })]
        })]
      })]
    }) : /*#__PURE__*/_jsx(CommonPriceView, {
      className: "mt-3",
      title: "Annual premium (including IPT):",
      content: (payPriceInfo === null || payPriceInfo === void 0 ? void 0 : payPriceInfo.currentPayPremiumText) || '-'
    }), /*#__PURE__*/_jsx(Box, {
      className: "my-4 h-px bg-[#0E35D130]"
    }), /*#__PURE__*/_jsx(CommonPriceView, {
      title: "Total annual payable:",
      content: (payPriceInfo === null || payPriceInfo === void 0 ? void 0 : payPriceInfo.annualCurrentPayText) || '-'
    })]
  });
};

export default PriceComparisonOnlyJovePriceInfoView;